/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:15:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-07 11:55:54
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/ContentCategory/Root/index.tsx
 */
import React from 'react';
import { useDispatch } from 'react-redux';

import HOC from '../HOC';
// import {
//   getContent,
//   getCollapse,
//   onCollapseChange,
//   getLoaded,
//   getMoveList,
// } from '../slice';
// import Table from '../Table';
// import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
// import Top from 'src/pages/SalesChannelCategory/Components/Card';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import RootModal from 'src/pages/SalesChannelCategory/Components/EditModal/Root';
import Header from 'src/pages/SalesChannelCategory/Components/Header';
import WrapperRoot from 'src/pages/SalesChannelCategory/Components/RootWrapper';
import Card from 'src/pages/SalesChannelCategory/PagesCategory/ContentCategory/Card';
import { submitChange } from 'src/pages/SalesChannelCategory/PagesCategory/ContentCategory/EditModal/tools';
import { i18nGet } from 'src/tools/tools';
import { onDataUpdate } from '../slice';

const Root = (props) => {
  const _d = useDispatch();

  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    moveList,
    salesChannelUuid,
    userPermissions,
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
  } = props;
  //console.log(salesChannelUuid);
  const { uuid, name, urlSlug } = data || {};

  const handleOnDataUpdate = (data: any) => {
    _d(onDataUpdate({ data }));
    onModalCancel();
  };
  //====request

  const submissionId = `postCategoryLegal${salesChannelUuid}`;
  const requestId = [submissionId];

  const _submitChange = ({ urlSlug, name }) => {
    return submitChange({
      salesChannelUuid,
      selfUuid: uuid,
      requestId: submissionId,
      urlSlug,
      name,
      onOk: handleOnDataUpdate,
      parentUuid: null,
    });
  };
  //===request
  const onEdit = () => {
    setModalTitle(getI18n('salesChannelCategoryPages.index.editCategory'));
    setModalContent(
      <RootModal
        onOk={handleOnDataUpdate}
        salesChannelUuid={salesChannelUuid}
        onCancel={onModalCancel}
        name={name}
        urlSlug={urlSlug}
        uuid={uuid}
        requestId={requestId}
        onSubmit={_submitChange}
        slugCheckingUrl={'portal/salesChannel/category/content/checkUrlSlug'}
      />,
    );
    setShowModal(true);
  };

  return (
    <React.Fragment>
      <Card
        // name={name}
        // slug={urlSlug}
        // uuid={`rootContent${uuid}`}
        // products={salesChannelItems}
        contentList={[
          [
            {
              label: getI18n('general.categoryName'),
              value: name,
            },
            {
              label: getI18n('general.uRLSlug'),
              value: urlSlug,
            },
          ],
        ]}
        moveList={moveList}
        salesChannelUuid={salesChannelUuid}
        isRoot
        canEdit={userPermissions.canCreate}
        onEdit={onEdit}
      />
    </React.Fragment>
  );
};

export { Root };

export default WrapperRoot(
  HOC(Root, {
    titleGenerator: (data) => {
      const { name, fullUrl } = data;
      return (
        <Header
          title={name}
          url={fullUrl}
          subTitle={getI18nFromGeneral(
            'general.hOCTitle.pageCategoryRootSubTitle',
          )}
        />
      );
    },
  }),
);
